import { useMemo } from 'react';

const useTransformGatsbyData = (data) =>
  useMemo(() => {
    if (!data) {
      return {};
    }

    if (data.nodes) {
      return data.nodes.map((node) => {
        if (node.data) {
          return node.data;
        }

        return node;
      });
    }

    if (data.data) {
      return data.data;
    }

    return data;
  }, [data]);

export default useTransformGatsbyData;
